import React, { useState } from "react";
import Image from "../Tags/Image";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
import Text from "../Tags/Text";

export default function AlertBold({
  heading,
  description,
  icon = "",
  headingColor,
  descriptionColor,
  borderColor,
  bgColor,
}) {
  return (
    <div
      className={`p-2 border rounded-lg flex w-full items-center bg-background space-x-3 ${bgColor} ${borderColor}`}
    >
      {icon && <Image src={`/images/alerts/${icon}`} className="no-invert" />}
      <div className="space-y-0.5">
        {heading && (
          <Text size="md" className={`${headingColor}`}>
            {heading}
          </Text>
        )}
        {description && (
          <Text size="p" className={`${descriptionColor}`}>
            {description}
          </Text>
        )}
      </div>
    </div>
  );
}
